import { z } from 'zod';
export const structureOptionsTypes = z.union([
    z.literal('view'),
    z.literal('scope'),
    z.literal('field'),
    z.literal('filter'),
    z.literal('form'),
    z.literal('view-field'),
    z.literal('navigation'),
]);
export const structureAiAssistantPrefix = z.object({
    type: structureOptionsTypes,
    value: z.string(),
});
export const structureAiAssistant = z.object({
    prefix: structureAiAssistantPrefix.optional(),
});
export const structureSliceState = z.object({
    isStructureGenerating: z.boolean().optional().nullable(),
    dsl: z.object({
        past: z.array(z.string()),
        present: z.string(),
        future: z.array(z.string()),
    }),
    pendingDsl: z.string().optional(),
    crudDsl: z.string().optional().nullable(),
    cleanedDsl: z.string().optional().nullable(),
    aiAssistant: structureAiAssistant.optional(),
    showMenuPanel: z.boolean().optional().nullable(),
    structureVisualizer: z
        .object({
        nodes: z.array(z.any()),
        edges: z.array(z.any()),
        viewport: z.any(),
    })
        .optional()
        .nullable(),
});
//# sourceMappingURL=structureSlice.js.map